/*
 * <usp-index> — entrance reveal for the PDP "spec index" USP block.
 * ---------------------------------------------------------------------------
 * When the block scrolls into view it gains `is-in`, which lets the hairline
 * rules draw in from the left and the rows rise/fade (staggered per row via
 * the --usp-i custom property set in Liquid).
 *
 * Enhancement only: the block marks itself `usp-index--ready` on connect, and
 * the CSS "hidden until revealed" state is gated on that class — so without JS
 * (or before upgrade) the content is fully visible. Motion is skipped entirely
 * under prefers-reduced-motion.
 */
(function () {
  'use strict';

  class UspIndex extends HTMLElement {
    connectedCallback() {
      // Signal JS is live so the pre-reveal (hidden) CSS state can apply.
      this.classList.add('usp-index--ready');

      var reduce =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduce || typeof IntersectionObserver === 'undefined') {
        this.classList.add('is-in');
        return;
      }

      this._observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-in');
              obs.disconnect();
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
      );

      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  }

  if (!customElements.get('usp-index')) {
    customElements.define('usp-index', UspIndex);
  }
})();
